import { render } from "./ProjetPortfolio.vue?vue&type=template&id=3f88f754&scoped=true"
import script from "./ProjetPortfolio.vue?vue&type=script&lang=js"
export * from "./ProjetPortfolio.vue?vue&type=script&lang=js"

import "./ProjetPortfolio.vue?vue&type=style&index=0&id=3f88f754&lang=scss&scoped=true"

import exportComponent from "/home/maud/code/ixperya2.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f88f754"]])

export default __exports__